import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import Header from '../Component/Header'
import Footer from '../Component/Footer'

const Faculties = () => {
    useEffect(() => {
        document.title = 'Faculties - Jai Rani Public School, Balussery';
    }, []);
    return (
        <>
            <Header />
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>About </li>
                    <li>Faculties</li>
                </ul>
            </div>
            <div className="innersec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1>Faculties</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div class="table-responsive text-center">
                                <table class="table table-striped table-bordered table-hover align-middle">
                                    <thead class="table-primary">
                                        <tr>
                                            <th scope="col">Sl. No</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Designation</th>
                                            <th scope="col">Qualification</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr><td>1</td><td>Sr.ANUSHA MATHEW</td><td>PRINCIPAL</td><td>M A, B Ed</td></tr>
                                        <tr><td>2</td><td>SONIMON XAVIER</td><td>Vice Principal</td><td>M A, B Ed</td></tr>
                                        <tr><td>3</td><td>AKSHAY K</td><td>PET</td><td>B PEd</td></tr>
                                        <tr><td>4</td><td>ALEENA THOMAS</td><td>TGT</td><td>M Sc, B Ed</td></tr>
                                        <tr><td>5</td><td>AMAL THOMAS</td><td>PRT</td><td>M A, B Ed</td></tr>
                                        <tr><td>6</td><td>AMBILY JOSEPH</td><td>PRT</td><td>M A, M Ed</td></tr>
                                        <tr><td>7</td><td>AMRUTHA BALAN</td><td>TGT</td><td>M Tech</td></tr>
                                        <tr><td>8</td><td>ANGELENA</td><td>PRT</td><td>M A B Ed</td></tr>
                                        <tr><td>9</td><td>ANITTA JOSE</td><td>PRT</td><td>D EL ED</td></tr>
                                        <tr><td>10</td><td>ANJU PIOUS</td><td>PRT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>11</td><td>ANU C</td><td>TGT</td><td>MSc, B Ed</td></tr>
                                        <tr><td>12</td><td>ARUN U K</td><td>PET</td><td>CPED</td></tr>
                                        <tr><td>13</td><td>ASHA N P</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>14</td><td>ASWATHI G</td><td>TGT</td><td>Sahithyacharya, MBA</td></tr>
                                        <tr><td>15</td><td>BINDU A.K.</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>16</td><td>BINSHA M M</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>17</td><td>CHINJU LAKSHMANAN</td><td>PRT</td><td>B TECH</td></tr>
                                        <tr><td>18</td><td>DILNA JOSE</td><td>TGT</td><td>M Sc, B Ed</td></tr>
                                        <tr><td>19</td><td>DIVYA K M</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>20</td><td>DIVYA M P</td><td>PRT</td><td>B Sc, PGDCA</td></tr>
                                        <tr><td>21</td><td>GEETHA O C</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>22</td><td>JEEBA M KURIAN</td><td>PRT</td><td>B A, T T C</td></tr>
                                        <tr><td>23</td><td>JINCY THOMAS</td><td>Sp. Educator</td><td>DSE MR</td></tr>
                                        <tr><td>24</td><td>JINSI M P</td><td>PET</td><td>B PEd</td></tr>
                                        <tr><td>25</td><td>JISHA RAJ</td><td>PRT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>26</td><td>JOSWIN SUNNY</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>27</td><td>LAJNA N P</td><td>PRT</td><td>BNYC, M A</td></tr>
                                        <tr><td>28</td><td>LINEESH K T</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>29</td><td>MINI N P</td><td>PRT</td><td>M A, B Ed</td></tr>
                                        <tr><td>30</td><td>MINISHA T P</td><td>PRT</td><td>B A vocal</td></tr>
                                        <tr><td>31</td><td>PRABEENA K</td><td>TGT</td><td>B A, B Ed</td></tr>
                                        <tr><td>32</td><td>PREETHI M M</td><td>PET</td><td>C PEd</td></tr>
                                        <tr><td>33</td><td>REENA JOHN</td><td>TGT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>34</td><td>REGEENA CHACKO</td><td>Wellness Tr</td><td>M SC</td></tr>
                                        <tr><td>35</td><td>RIJI K</td><td>TGT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>36</td><td>SARITHA K</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>37</td><td>SHIJI E K</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>38</td><td>SHRUDHIMOL JOSEPH</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>39</td><td>SILPA N K</td><td>PRT</td><td>M A, B Ed</td></tr>
                                        <tr><td>40</td><td>SINDU V V K</td><td>PRT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>41</td><td>SMITHA ALEX</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>42</td><td>SNEHA GEORGE</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>43</td><td>SOBHA P M</td><td>PRT</td><td>M A, B Ed</td></tr>
                                        <tr><td>44</td><td>SOUMYA M K</td><td>TGT</td><td>B A, B Ed PGDCA</td></tr>
                                        <tr><td>45</td><td>Sr.LALYKUTTY JOSEPH</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>46</td><td>SREEKALA P P</td><td>TGT</td><td>M A, B Ed</td></tr>
                                        <tr><td>47</td><td>SREELEKHA MOHAN</td><td>PRT</td><td>M A, B Ed</td></tr>
                                        <tr><td>48</td><td>TENSY CHACKO</td><td>PRT</td><td>B A, B Ed</td></tr>
                                        <tr><td>49</td><td>UNNIMAYA T V</td><td>TGT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>50</td><td>VIDYA V</td><td>PRT</td><td>B Sc, B Ed</td></tr>
                                        <tr><td>51</td><td>VINISHA MOHAN K</td><td>TGT</td><td>B Sc, B Ed</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Faculties;
